import React, { useRef, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import './GlossaryHelpPage.scss';
import { GlossaryHelpPageVM } from './GlossaryHelpPageVM';

const GlossaryHelpSummaryComponent = (props) => {
    const vm = useRef(new GlossaryHelpPageVM()).current;

    const onClickHandler = (itemClicked) => {
        props.updateSummaryName(itemClicked)
    }

    return (
        <div className='summary-bottom-right'>
            <h2 className='glossary-summary-details' tabIndex={0}>Glossary and Help Categories</h2>
            {props.glossData?.map(item => (
                <>
                    {item.categoryName === "" ? <><button className='usa-button--unstyled' key={item + 'summary'} onClick={() => onClickHandler(item.categoryName)} aria-label={'No Catogery' + " " + item.count + 'items'} >Empty({item.count}) </button><br></br></> : <><button className='usa-button--unstyled' key={item + 'summary'} onClick={() => onClickHandler(item.categoryName)} aria-label={item.categoryName + "  " + item.count + 'item'}>{item.categoryName}({item.count})</button><br></br></>}
                </>
            ))}
            {/*to get all the items on glossary page*/}
            <button className='usa-button--unstyled' onClick={() => onClickHandler('all')}>All</button>
            <button className="usa-button usa-button-new bottom-right" title='Go to Top' onClick={props.handleScroll}>Return to Top</button>
        </div>
    )

};

export const GlossaryHelpSummary = observer(GlossaryHelpSummaryComponent);

